import CryptoJS from "crypto-js";

export default {
  methods: {
    gtmAddToCart(examination, email) {
      this.gtmTrackExaminationEvent(
        "add_to_cart",
        [examination],
        undefined,
        undefined,
        email
      );
    },
    gtmRemoveFromCart(examination, email) {
      this.gtmTrackExaminationEvent(
        "remove_from_cart",
        [examination],
        undefined,
        undefined,
        email
      );
    },
    gtmBeginCheckout(examinations, facility, transaction_id, email) {
      this.gtmTrackExaminationEvent(
        "begin_checkout",
        examinations,
        facility,
        transaction_id,
        email
      );
    },
    gtmViewCart(examinations, facility, email) {
      this.gtmTrackExaminationEvent(
        "view_cart",
        examinations,
        facility,
        undefined,
        email
      );
    },
    gtmTrackExaminationEvent(
      event,
      examinations,
      facility,
      transaction_id,
      email
    ) {
      const items = examinations.map((examination) => {
        const {
          id,
          service_id,
          name,
          slug,
          price,
          package: is_package,
        } = examination;

        return {
          id,
          service_id,
          name,
          slug,
          price,
          is_package,
        };
      });
      const value = items.reduce((total, item) => total + item.price * 1, 0);

      const ecommerceData = {
        currency: "PLN",
        value,
        items,
      };

      if (facility) {
        ecommerceData.facility_id = facility;
      }
      if (transaction_id) {
        ecommerceData.transaction_id = transaction_id;
      }
      if (email) {
        ecommerceData.email = email;
        ecommerceData.sha256_email = CryptoJS.SHA256(email).toString(
          CryptoJS.enc.Hex
        );
        ecommerceData.md5_email = CryptoJS.MD5(email).toString(
          CryptoJS.enc.Hex
        );
      }

      this.$gtm.trackEvent({ ecommerce: null });
      this.$gtm.trackEvent({
        event,
        ecommerce: ecommerceData,
      });
    },
  },
};
